// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2fLAk","requiredAsterisk":"Info_requiredAsterisk__39AqK"};